import { graphql } from '@/gql';
import type { CancelLocalTaxiScheduledRideMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const cancelLocalTaxiScheduledRide = async ({
  scheduledRideId,
  cancellationReason,
  canceledByType,
  isReschedule,
}: CancelLocalTaxiScheduledRideMutationVariables): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CancelLocalTaxiScheduledRide(
        $scheduledRideId: Float!
        $cancellationReason: String!
        $canceledByType: CanceledByType!
        $isReschedule: Boolean
      ) {
        cancelLocalTaxiScheduledRide(
          scheduledRideId: $scheduledRideId
          cancellationReason: $cancellationReason
          canceledByType: $canceledByType
          isReschedule: $isReschedule
        )
      }
    `),
    variables: {
      scheduledRideId,
      cancellationReason,
      canceledByType,
      isReschedule,
    },
  });

  return response.data?.cancelLocalTaxiScheduledRide ?? false;
};
